import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Init_des } from '../../components/Javascript/Init_des'
export const E1 = props => {
  return (
    <>
      <Init_des
      title="OH YUVA! - UNLEASH YOUR SUPERPOWER"
      date=" August 15, 2021"
      village=" Online Ms Team"
        p1="The hope of having a vision of changing the world resides within. We have to take part and be the catalyst of change. After all, ‘You cannot cross the sea merely by standing and staring at the water.’"

        p2="Youth has a limitless potential to do wonders and the ability to explore unknown boundaries. The biggest reason that makes them more powerful than the rest of society is their ability to take the risk for a change."

        p3="On the 75th Independence Day, Team UBA IIT Roorkee brought one-of-its-kind talk by Mr Swapnil Tewari on the topic- 'O Yuva! - Unleash your superpower'.
        Cited in the '1000 World Leaders for Hope' list, Forbes Magazine's Changemakers 30 under 30 list, and a mentor to 537 social entrepreneurs, Mr Swapnil is a constant guide to the Youth across the globe. A dyslexic and synaesthetic by birth, his work explores the synergy and congruence of human senses and the ability to explore alternative intelligence among people. His life’s work has been dedicated to spreading hope in troubled communities through education, social inventions, hope, and love."
      />
    </>
  )
}
